import { contestants, faqs, site } from "@/mocks/chigua";

const topList = [...contestants].sort((a, b) => b.heat - a.heat).slice(0, 10);

const faqData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const itemListData = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "吃瓜大赛选手盘点热门瓜料 TOP10",
  numberOfItems: topList.length,
  itemListOrder: "https://schema.org/ItemListOrderDescending",
  itemListElement: topList.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
  })),
};

const orgData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "吃瓜大赛2026选手盘点",
  description: site.desc,
  inLanguage: "zh-CN",
  isPartOf: { "@type": "WebSite", name: site.brand },
};

export default function Schema() {
  const scripts = [faqData, itemListData, orgData];
  return (
    <>
      {scripts.map((s, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }}
        />
      ))}
    </>
  );
}